import React from 'react';
import { useTheme } from '@/providers/ThemeProvider';
import { IoSunny, IoMoon } from 'react-icons/io5';
import VerticalSeparator from '@/components/ui/base/VerticalSeparator';

interface DarkModeProps {
  className?: string;
}

export const DarkMode = ({ className }: DarkModeProps) => {
  const { theme, setTheme } = useTheme();

  const handleKeyDown = (event: React.KeyboardEvent) => {
    if (event.key === 'Enter' || event.key === ' ') {
      setTheme(theme === 'light' ? 'dark' : 'light');
    }
  };

  const toggleTheme = () => {
    setTheme(theme === 'light' ? 'dark' : 'light');
  };

  const isLightMode = theme === 'light';

  return (
    <div className={`flex items-center gap-2 ${className}`}>
      <div className="flex h-8 items-center">
        <button
          disabled={isLightMode}
          onClick={!isLightMode ? toggleTheme : undefined}
          onKeyDown={handleKeyDown}
          className={`flex h-10 w-10 items-center justify-center rounded-full ${
            !isLightMode ? 'hover:bg-[#ededed] dark:hover:bg-[#282828]' : ''
          }`}
        >
          <IoSunny
            className={`text-xl ${
              isLightMode
                ? 'text-neutralText'
                : 'cursor-pointer text-neutralText-dark opacity-30'
            }`}
          />
        </button>
      </div>
      <VerticalSeparator />
      <div>
        <button
          disabled={!isLightMode}
          onClick={isLightMode ? toggleTheme : undefined}
          onKeyDown={handleKeyDown}
          className={`flex h-10 w-10 items-center justify-center rounded-full ${
            isLightMode ? 'hover:bg-[#ededed] dark:hover:bg-[#282828]' : ''
          }`}
        >
          <IoMoon
            className={`text-lg ${
              isLightMode
                ? 'cursor-pointer text-neutralText opacity-30'
                : 'text-neutralText-dark'
            }`}
          />
        </button>
      </div>
    </div>
  );
};
